<template>
  <div class="goods-order-list">
    <app-header :title="title" leftName="false" />
    <div class="goods-info info-top">
      <div class="goods-total">
        <div class="title">历史消费</div>
        <div class="money">￥{{ discountTotal }}</div>
      </div>
    </div>
    <div class="goods-info info-middle">
      <!-- 折线 -->
      <div class="line-broken">
        <div class="circle left"></div>
        <div class="line"></div>
        <div class="circle right"></div>
      </div>
    </div>
    <div class="goods-info info-bottom">
      <div class="tip">若以前在友邻少年消费过，允许购买无限卡时抵扣之前消费金额</div>
      <div class="goods-table">
        <div class="table">
          <div class="row row-title">
            <span class="column col-name">商品名称</span>
            <span class="column col-price">实付金额</span>
            <span class="column">购买时间</span>
          </div>
          <div class="row" v-for="(item, index) in discountList" :key="index">
            <span class="column col-name">{{ item.goodsName }}</span>
            <span class="column col-price">{{ item.realPayAmount }}元</span>
            <span class="column">{{ momentDate(item) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-tip">
      <img class="icon-24" src="../../../images/goods-vip-forever/icon-tip.png" alt="" />
      提示：若订单数据缺少，可联系班主任
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Body from '@/mixins/body'
import $moment from 'moment'
import { toLoginView } from '@/utils/init/env-init'
import { appUser } from '@/utils'

export default {
  name: 'goodsDiscountList',
  mixins: [Body],
  computed: {
    ...mapGetters('payment/order', ['preOrder', 'disCountOrderList']),
    discountList() {
      // return [{ goodsName: 'test' }, { goodsName: 'test' }, { goodsName: 'test' }]
      return this.disCountOrderList.discountInfoList || []
    },
    discountTotal() {
      const total = this.disCountOrderList.discountTotal
      return total
    }
  },
  data() {
    return {
      title: '消费详情'
    }
  },
  created() {
    // 如果没有登录，先去登录
    if (!this.hasUser()) {
      return
    }
    this.enterAfterLogin()
  },

  methods: {
    // 检查用户
    hasUser() {
      // 无token去登录
      const action = 'discount'
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      this.enterAfterLogin()
    },
    enterAfterLogin() {
      const isLocal = location.href.indexOf('localhost') >= 0
      const isTest = location.href.indexOf('test') >= 0
      const bool = isLocal || isTest
      const { userId } = appUser
      this.$store.dispatch('payment/order/getDisCountOrderList', {
        goodsId: bool ? '104128' : '103098',
        userId
      })
    },
    momentDate(item) {
      return $moment(item.createTime).format('YYYY.M.DD')
    }
  }
}
</script>

<style lang="scss">
.body-goods-order-list {
  background-color: #f7f9fb;
}
</style>
<style lang="scss" scoped>
.goods-order-list {
  .goods-info {
    margin: 0.48rem;
    background: #ffffff;
    padding: 0.44rem;
    &.info-middle {
      margin: -0.48rem 0.48rem;
      padding: 0rem;
    }
    .goods-total {
      text-align: center;
      margin-top: 0.8rem;
      font-size: 0.36rem;
      .title {
        font-size: 0.4rem;
        height: 1rem;
      }
      .money {
        color: #00b25a;
        font-size: 0.9rem;
        height: 1rem;
      }
    }
    .tip {
      color: #333333ff;
      font-size: 0.28rem;
      line-height: 0.4rem;
      margin-bottom: 0.4rem;
      text-align: left;
    }
    // 分割线
    .line-broken {
      height: 0.4rem;
      display: flex;
      justify-self: start;
      overflow: hidden;
      .circle {
        width: 0.4rem;
        border-radius: 30rem;
        background: #f7f9fb;
        &.left {
          margin-left: -0.22rem;
        }
        &.right {
          margin-right: -0.22rem;
        }
      }
      .line {
        border-top: 1px dashed #d9d9d9;
        flex: 1;
        margin-top: 0.2rem;
      }
    }
    .goods-table {
      .row {
        color: #666666ff;
        font-size: 0.3rem;
        line-height: 0.4rem;
        margin-top: 0.2rem;
        display: flex;
        &.row-title {
          color: #999999ff;
          font-size: 0.3rem;
          line-height: 0.56rem;
        }
        .column {
          flex: 2;
          // text-overflow: ellipsis;
          // display: -webkit-box;
          // -webkit-line-clamp: 1;
          // -webkit-box-orient: vertical;
          // overflow: hidden;
          padding-right: 0.1rem;
          &.col-price {
            text-align: center;
          }
          &:last-child {
            text-align: right;
            padding-right: 0;
          }
          &.col-name {
            flex: 3;
          }
        }
      }
    }
  }
  .bottom-tip {
    text-align: center;
    margin: 0.48rem;
    color: #666666ff;
    font-size: 0.28rem;
    .icon-24 {
      vertical-align: sub;
      margin-right: 0.08rem;
      width: 0.3rem;
    }
  }
}
</style>
